import React from 'react';
import PropTypes from 'prop-types';

const ToolbarTitle = ({ title, titleClass = 'forge-typography--heading4', slot = 'start' }) => {
  return <h3 slot={slot} className={titleClass}>{title}</h3>;
};

ToolbarTitle.propTypes = {
  title: PropTypes.string.isRequired,
  titleClass: PropTypes.string,
  slot: PropTypes.string,
};

export default ToolbarTitle;
